import React from 'react';
import { AlertTriangle, Smartphone, BookOpen, MicOff } from 'lucide-react';
export function OldSolutionsFail() {
  return <section className="py-20 bg-white px-4 border-b border-gray-100" data-id="element-133">
      <div className="max-w-4xl mx-auto" data-id="element-134">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-135">
          Por qué lo que ya intentaste te dejó igual{' '}
          <span className="text-gray-400" data-id="element-136">(o peor)</span>
        </h2>

        <div className="space-y-6" data-id="element-137">
          <div className="flex flex-col md:flex-row gap-6 p-6 rounded-2xl bg-gray-50 hover:bg-gray-100 transition-colors" data-id="element-138">
            <div className="flex-shrink-0" data-id="element-139">
              <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-sm text-gray-400" data-id="element-140">
                <Smartphone className="w-6 h-6" data-id="element-141" />
              </div>
            </div>
            <div data-id="element-142">
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-143">Apps</h3>
              <p className="text-gray-600" data-id="element-144">
                Te dan palabras sueltas. La vida real no habla en flashcards.
              </p>
            </div>
          </div>

          <div className="flex flex-col md:flex-row gap-6 p-6 rounded-2xl bg-gray-50 hover:bg-gray-100 transition-colors" data-id="element-145">
            <div className="flex-shrink-0" data-id="element-146">
              <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-sm text-gray-400" data-id="element-147">
                <BookOpen className="w-6 h-6" data-id="element-148" />
              </div>
            </div>
            <div data-id="element-149">
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-150">
                Cursos tradicionales
              </h3>
              <p className="text-gray-600" data-id="element-151">
                Te prometen conversación “después” (y ese “después” se alarga).
              </p>
            </div>
          </div>

          <div className="flex flex-col md:flex-row gap-6 p-6 rounded-2xl bg-gray-50 hover:bg-gray-100 transition-colors" data-id="element-152">
            <div className="flex-shrink-0" data-id="element-153">
              <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-sm text-gray-400" data-id="element-154">
                <MicOff className="w-6 h-6" data-id="element-155" />
              </div>
            </div>
            <div data-id="element-156">
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-157">
                “Pierde el acento”
              </h3>
              <p className="text-gray-600" data-id="element-158">
                Te pone una meta imposible → perfeccionismo → silencio.
              </p>
            </div>
          </div>
        </div>

        <div className="mt-10 p-6 bg-yellow-50 border border-yellow-200 rounded-xl flex items-start gap-4" data-id="element-159">
          <AlertTriangle className="w-6 h-6 text-yellow-600 flex-shrink-0 mt-1" data-id="element-160" />
          <p className="text-yellow-800 font-medium text-lg" data-id="element-161">
            Te dijeron “practica más”. Nadie te dijo qué decir cuando te trabas.
          </p>
        </div>
      </div>
    </section>;
}